import React from 'react';
import {
    AllAssets,
    AllAssetsFilter, AllBlockers,
    AllFindings,
    AllFindingsFilter, AllHighRiskAssets, AllPentests, AllPentestsFilter, AssetDashboard, AssetDescAndUserStories, Chat,
    CTEMDashboard,
    CustomerSelection,
    Dashboard, EditAssetScope, EnterpriseDashboard,
    PentestFindingDashboard, MyCustomers, PentestDashboard, PentestLandscape, PreRequisites, QualysFindingDashboard, ScanQualysFindingDashboard, VADashboard
} from "../pages/PageListAsync";
import { Route, Routes, Navigate } from "react-router-dom";
import Layout from "../../components/Admin/Layout";
import LayoutProvider from "../../Providers/LayoutProvider";
import withPermissions from "../../hoc/withPermissions";
import { SIEMBA_TESTER } from "../../utils/roles";
import DraftFindings from '../pages/MyDashboard/FindingDashboard/DraftFindings';
import VulnerabilityAssessment from '../pages/Admin/VulnerabilityAssessment';
import AllVAVulnerabilities from '../pages/Admin/VulnerabilityAssessment/AllVAVulnerabilities';
import OverallVADashboard from '../pages/MyDashboard/AssetDashboard/OverallVADashboard/OverallVADashboard';

const TesterRoutes = () => {
    return (
        <LayoutProvider value={{
            dashboard: "TESTER_DASHBOARD",
            mainUrl: "/tester"
        }}>
            <Layout>
                <Routes>
                    <Route path={"/"} element={<Navigate to={"/tester/dashboard"} />} />
                    <Route path={"/dashboard"} element={<Dashboard dashboard={"TESTER_DASHBOARD"} />} />
                    <Route path={"dashboard/:company_id/enterprise_dashboard"} element={<EnterpriseDashboard />} />
                    <Route path={"customers"} element={<MyCustomers />} />
                    <Route path={"all_va"} element={<VulnerabilityAssessment />} />
                    <Route path={"va/all_findings"} element={<AllVAVulnerabilities />} />
                    <Route path={"va_overview"} element={<OverallVADashboard />} />

                    {/* CTEM dashboard */}
                    <Route path={"dashboard/:companyId/ctem_dashboard"} element={<CTEMDashboard />} />

                    {/*findings*/}
                    <Route path={"/dashboard/draft_findings"} element={<DraftFindings />} />
                    <Route path={"/pentests/all_findings"} element={<AllFindings />} />
                    <Route path={"/dashboard/:company_id/all_findings"} element={<AllFindings />} />
                    <Route path={"/pentests/all_findings/:id/dashboard"} element={<PentestFindingDashboard />} />
                    <Route path={"/pentests/all_findings/:filter"} element={<AllFindingsFilter />} />
                    <Route path={"/dashboard/:company_id/all_findings/:filter"} element={<AllFindingsFilter />} />
                    <Route path={"/va/all_findings/:findingId/dashboard"} element={<QualysFindingDashboard />} />
                    <Route path={"/all_va/finding/:findingId/dashboard"} element={<ScanQualysFindingDashboard />} />
                    {/*assets*/}
                    <Route path={"/all_assets"} element={<AllAssets />} />
                    <Route path={"/all_assets/riskiest_assets"} element={<AllHighRiskAssets />} />
                    <Route path={"/all_assets/riskiest_assets/:pentest_id"} element={<AllHighRiskAssets />} />
                    <Route path={"/all_assets/:id/dashboard"} element={<AssetDashboard />} />
                    <Route path={"/all_va/:assetId/dashboard"} element={<VADashboard />} />
                    <Route path={"/all_assets/:filter"} element={<AllAssetsFilter />} />
                    <Route path={"/all_assets/:company_id/:filter"} element={<AllAssetsFilter />} />
                    <Route path={"/all_assets/:id/edit_scope"} element={<EditAssetScope />} />
                    <Route path={"/all_assets/:id/asset_desc_and_user_stories"} element={<AssetDescAndUserStories />} />
                    <Route path={"/all_assets/:asset_id/all_findings"} element={<AllFindings />} />
                    <Route path={"/all_assets/:asset_id/all_findings/:filter"} element={<AllFindingsFilter />} />
                    <Route path={"/all_assets/:asset_id/pre_requisites"} element={<PreRequisites />} />
                    {/*pentests*/}
                    <Route path={"/all_pentests"} element={<AllPentests />} />
                    <Route path={"/pentests/:filter"} element={<AllPentestsFilter />} />
                    <Route path={"/all_pentests/:id/dashboard"} element={<PentestDashboard />} />
                    <Route path={"/all_pentests/:pentest_id/all_findings"} element={<AllFindings />} />
                    <Route path={"/all_pentests/:pentest_id/pentest_landscape"} element={<PentestLandscape />} />
                    <Route path={"/all_pentests/:pentest_id/all_findings/:filter"} element={<AllFindingsFilter />} />
                    <Route path={"/pentests/insights"} element={<CustomerSelection />} />
                    <Route path={"pentests/insights/:company_id"} element={<EnterpriseDashboard />} />
                    {/*blockers*/}
                    <Route path={"/pentests/all_blockers"} element={<AllBlockers />} />
                    <Route path={"/dashboard/:company_id/all_blockers"} element={<AllBlockers />} />
                    <Route path={"/chat"} element={<Chat />} />
                    <Route path={"/chat/:conversation_id"} element={<Chat />} />
                </Routes>
            </Layout>
        </LayoutProvider>
    );
};

export default withPermissions(TesterRoutes, { roles: [SIEMBA_TESTER] });
